import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiChevronDown } from "react-icons/hi2";
import "./FAQ.css";

const faqs = [
  {
    q: "¿Cuánto tiempo tarda en desarrollarse un proyecto web típico?",
    a: "Depende del alcance: un landing page optimizado puede estar listo en 5–7 días. Un proyecto con backend, autenticación y panel admin suele tomar de 3 a 6 semanas. Siempre entrego un roadmap detallado antes de comenzar.",
  },
  {
    q: "¿Trabajas con clientes fuera de México?",
    a: "Sí, trabajo con clientes en toda Latinoamérica, España y USA. Me coordino en husos horarios GMT-6 a GMT+1. Los pagos se gestionan via PayPal, Wise o transferencia bancaria internacional.",
  },
  {
    q: "¿Qué stack de tecnología recomiendas para un SaaS en 2025?",
    a: "Para la mayoría de SaaS recomiendo Next.js (frontend + BFF), Node.js con Express o Fastify (API), PostgreSQL (datos relacionales), Redis (caché/sesiones) y deploy en Railway o Vercel. Todo containerizado con Docker.",
  },
  {
    q: "¿Pueden tus scripts de automatización Python correr 24/7 sin supervision?",
    a: "Sí. Configuro los scripts con manejo de errores robusto, retry logic, logging y alertas por Telegram o email. Se despliegan en VPS (DigitalOcean, Linode) o via GitHub Actions para ejecución programada.",
  },
  {
    q: "¿Los sitios que desarrollas están optimizados para SEO?",
    a: "Siempre. Implemento meta tags dinámicos, Open Graph, sitemap.xml, robots.txt, Schema.org structured data, y optimización de Core Web Vitals. Con Next.js el SSR/SSG garantiza indexación completa por buscadores.",
  },
  {
    q: "¿Ofreces mantenimiento post-entrega?",
    a: "Sí, ofrezco planes de mantenimiento mensual que incluyen: actualizaciones de dependencias, monitoreo de uptime, corrección de bugs, pequeñas mejoras y reportes de rendimiento. Consulta las tarifas por correo.",
  },
];

const FAQ = React.memo(function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="faq">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="section-label">FAQ</span>
          <h2 className="section-title">Preguntas Frecuentes</h2>
          <p className="section-subtitle">
            Respuestas directas para clientes que saben lo que buscan.
          </p>
        </motion.div>

        <div className="faq-list">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <motion.div
                key={i}
                className={`faq-item glass-card ${isOpen ? "faq-item--open" : ""}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: i * 0.06, duration: 0.5 }}
              >
                <button
                  className="faq-trigger"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                >
                  <span className="faq-question">{faq.q}</span>
                  <motion.span
                    className="faq-chevron"
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
                  >
                    <HiChevronDown />
                  </motion.span>
                </button>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      className="faq-body"
                      key="body"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
                    >
                      <p className="faq-answer">{faq.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>

        {/* Bottom hint */}
        <motion.p
          className="faq-footer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
        </motion.p>
      </div>
    </section>
  );
});

export default FAQ;
